var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 0H1.33328C0.597059 0 0 0.584874 0 1.30607V14.6939C0 15.4151 0.597059 16 1.33328 16H19.6667C20.4029 16 21 15.4151 21 14.6939V1.30607C21 0.584874 20.4029 0 19.6667 0ZM19.6667 1.30607V10.8052L17.0391 8.46499C16.6441 8.11316 16.0367 8.12736 15.6593 8.49748L12.9999 11.1021L7.75643 4.96657C7.35991 4.50308 6.63399 4.49823 6.23175 4.95649L1.33328 10.533V1.30607H19.6667ZM14 4.73464C14 3.74267 14.8205 2.93856 15.8331 2.93856C16.8458 2.93856 17.6666 3.7423 17.6666 4.73464C17.6666 5.72698 16.8461 6.53072 15.8331 6.53072C14.8209 6.53072 14 5.72661 14 4.73464Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.2432b350.svg";
export { ForwardRef as ReactComponent };